import React from "react";

export type ContextDropdownsPersistence<T> = {
  options: T[],
  loading: boolean;
}

export type StepsContextType = {}

export const StepsContext = React.createContext<StepsContextType>({} as StepsContextType);